import { render, staticRenderFns } from "./ShowContenidoBookArtiTab.vue?vue&type=template&id=250f5136&scoped=true"
import script from "./ShowContenidoBookArtiTab.vue?vue&type=script&lang=js"
export * from "./ShowContenidoBookArtiTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f5136",
  null
  
)

export default component.exports